// import PropTypes from 'prop-types';

import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import React, { Fragment } from 'react'
import { styled } from "@mui/material/styles";
import { paths } from "../../routes/paths";
import { useResponsive } from '../../hooks/use-responsive';


export default function NoPlanSelected() {

    const navigate = useNavigate();

    const mdUp = useResponsive("up", "md");
    const CreateNew = styled(Button)(({ theme }) => ({
        backgroundColor: "#C7F760",
        color: "#1E53E8",
        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "& .icon-hover": {
            transition: "color 0.3s ease",
        },
        "&:hover": {
            backgroundColor: "#1E53E8",
            color: "#C7F760",
            "& .icon-hover": {
                color: "#FFFFFF", // Change the icon color to white on hover
            },
        },
    }));


    return (
        <Fragment>
                <Box sx={{ p: 2,  backgroundColor: '#F1F1F1', borderRadius: 5, width: 'auto', height: { xs: '657px', md: '532px' }, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    <Stack direction='column'  >
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            textAlign="center"
                            sx={{
                                color: '#1E53E8',
                                fontSize: { xs: '28px', md: '38px' },
                                fontFamily: 'Sofia Sans Extra Condensed',
                                fontWeight: '700',
                                lineHeight: { xs: '30px', md: '40px' },
                                wordWrap: 'break-word',
                                textTransform: "uppercase",
                            }}
                            gutterBottom
                        >
                            Create your own <br /> megaconnect cloud computer
                        </Typography>
                        <Grid
                            container
                            item
                            justifyContent="center"
                            md={12}
                        >
                            <CreateNew
                                  onClick={() => navigate(paths.dashboard.dashPlans)}
                                variant="contained"
                                fullWidth
                                size="large"
                                sx={{
                                    color: "#1E53E8",
                                    fontWeight: "bold",
                                    background: "#C7F760",
                                    padding: 1,
                                    borderRadius: 2,
                                }}
                            >
                                Create New
                            </CreateNew>
                        </Grid>
                    </Stack>
                </Box>


        </Fragment>
    )
}

// NoPlanSelected.propTypes = {
//     userDetails: PropTypes.object,
// };



// ----------------------------------------------------------------------

